// Mock data for Pinto Trading

export const companyInfo = {
  name: "Pinto Trading",
  shortName: "Pinto",
  tagline: "Your Trusted Global Trading Partner",
  email: "info@pintotradings.com",
  phone: "+1 (800) 915-3680",
  address: "Newark, NJ 07105, USA",
  workingHours: "Mon - Fri: 9:00 AM - 6:00 PM",
  founded: "2010",
  description: "Pinto Trading is a leading global trading company specializing in diverse product categories. With over a decade of experience, we connect suppliers and buyers worldwide, ensuring quality products and reliable service."
};

export const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "50+", label: "Countries Served" },
  { value: "1000+", label: "Happy Clients" },
  { value: "10K+", label: "Products Delivered" }
];

export const services = [
  {
    id: 1,
    title: "Import & Export",
    description: "Comprehensive import and export services across multiple continents with customs clearance support.",
    icon: "Globe"
  },
  {
    id: 2,
    title: "Wholesale Distribution",
    description: "Large-scale distribution network ensuring timely delivery of bulk orders worldwide.",
    icon: "Warehouse"
  },
  {
    id: 3,
    title: "Quality Assurance",
    description: "Rigorous quality control processes to ensure all products meet international standards.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Logistics Solutions",
    description: "End-to-end logistics management including shipping, warehousing, and last-mile delivery.",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Market Research",
    description: "In-depth market analysis to help you identify opportunities and make informed decisions.",
    icon: "TrendingUp"
  },
  {
    id: 6,
    title: "Custom Sourcing",
    description: "Personalized product sourcing services tailored to your specific business requirements.",
    icon: "Search"
  }
];

export const productCategories = [
  "Electronics",
  "Home & Kitchen",
  "Industrial",
  "Fashion & Textiles",
  "Health & Beauty",
  "Sports & Outdoors",
  "Office Supplies",
  "Automotive"
];

export const products = [
  // Electronics (1-8)
  { id: 1, name: "Wireless Bluetooth Headphones", category: "Electronics", price: 45.99, minOrder: 100, image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400" },
  { id: 2, name: "Smart LED Light Bulbs (Pack of 4)", category: "Electronics", price: 24.99, minOrder: 200, image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400" },
  { id: 3, name: "Portable Power Bank 20000mAh", category: "Electronics", price: 29.99, minOrder: 150, image: "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400" },
  { id: 4, name: "USB-C Fast Charging Cable", category: "Electronics", price: 8.99, minOrder: 500, image: "https://images.unsplash.com/photo-1558618047-f4b511863e1b?w=400" },
  { id: 5, name: "Wireless Mouse & Keyboard Combo", category: "Electronics", price: 35.99, minOrder: 100, image: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=400" },
  { id: 6, name: "Digital Kitchen Scale", category: "Electronics", price: 18.99, minOrder: 200, image: "https://images.unsplash.com/photo-1585515320310-259814833e62?w=400" },
  { id: 7, name: "Bluetooth Speaker Portable", category: "Electronics", price: 39.99, minOrder: 100, image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400" },
  { id: 8, name: "Smart Watch Fitness Tracker", category: "Electronics", price: 52.99, minOrder: 100, image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400" },
  
  // Home & Kitchen (9-16)
  { id: 9, name: "Stainless Steel Cookware Set", category: "Home & Kitchen", price: 89.99, minOrder: 50, image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400" },
  { id: 10, name: "Non-Stick Frying Pan", category: "Home & Kitchen", price: 22.99, minOrder: 100, image: "https://images.unsplash.com/photo-1574968730234-2ad092e71139?w=400" },
  { id: 11, name: "Electric Kettle 1.7L", category: "Home & Kitchen", price: 28.99, minOrder: 100, image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400" },
  { id: 12, name: "Bamboo Cutting Board Set", category: "Home & Kitchen", price: 19.99, minOrder: 200, image: "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?w=400" },
  { id: 13, name: "Glass Food Storage Containers", category: "Home & Kitchen", price: 34.99, minOrder: 100, image: "https://images.unsplash.com/photo-1610701596007-11502861dcfa?w=400" },
  { id: 14, name: "Silicone Kitchen Utensil Set", category: "Home & Kitchen", price: 24.99, minOrder: 150, image: "https://images.unsplash.com/photo-1590794056226-79ef3a8147e1?w=400" },
  { id: 15, name: "Coffee Maker Drip Machine", category: "Home & Kitchen", price: 49.99, minOrder: 50, image: "https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?w=400" },
  { id: 16, name: "Microfiber Cleaning Cloths (12 Pack)", category: "Home & Kitchen", price: 12.99, minOrder: 300, image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?w=400" },
  
  // Industrial (17-23)
  { id: 17, name: "Industrial Safety Gloves", category: "Industrial", price: 8.99, minOrder: 500, image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400" },
  { id: 18, name: "Heavy Duty Tool Box", category: "Industrial", price: 45.99, minOrder: 100, image: "https://images.unsplash.com/photo-1581147036324-c17ac41f24d8?w=400" },
  { id: 19, name: "Steel Wire Rope 10m", category: "Industrial", price: 29.99, minOrder: 200, image: "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=400" },
  { id: 20, name: "LED Work Light Rechargeable", category: "Industrial", price: 35.99, minOrder: 150, image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=400" },
  { id: 21, name: "Safety Helmet Hard Hat", category: "Industrial", price: 15.99, minOrder: 300, image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400" },
  { id: 22, name: "Industrial Tape Measure Set", category: "Industrial", price: 12.99, minOrder: 400, image: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400" },
  { id: 23, name: "Ratchet Wrench Set 40pc", category: "Industrial", price: 68.99, minOrder: 50, image: "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?w=400" },
  
  // Fashion & Textiles (24-31)
  { id: 24, name: "Cotton T-Shirts Plain (Bundle)", category: "Fashion & Textiles", price: 6.99, minOrder: 500, image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400" },
  { id: 25, name: "Denim Jeans Classic Fit", category: "Fashion & Textiles", price: 24.99, minOrder: 200, image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400" },
  { id: 26, name: "Leather Belt Premium", category: "Fashion & Textiles", price: 14.99, minOrder: 300, image: "https://images.unsplash.com/photo-1624222247344-550fb60583dc?w=400" },
  { id: 27, name: "Cotton Bed Sheet Set", category: "Fashion & Textiles", price: 32.99, minOrder: 100, image: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=400" },
  { id: 28, name: "Bath Towel Set (6 Piece)", category: "Fashion & Textiles", price: 28.99, minOrder: 150, image: "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=400" },
  { id: 29, name: "Winter Fleece Jacket", category: "Fashion & Textiles", price: 38.99, minOrder: 100, image: "https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=400" },
  { id: 30, name: "Canvas Tote Bag", category: "Fashion & Textiles", price: 9.99, minOrder: 400, image: "https://images.unsplash.com/photo-1544816155-12df9643f363?w=400" },
  { id: 31, name: "Wool Scarf Unisex", category: "Fashion & Textiles", price: 16.99, minOrder: 250, image: "https://images.unsplash.com/photo-1520903920243-00d872a2d1c9?w=400" },
  
  // Health & Beauty (32-38)
  { id: 32, name: "Natural Soap Bar Set", category: "Health & Beauty", price: 12.99, minOrder: 300, image: "https://images.unsplash.com/photo-1607006344380-b6775a0824a7?w=400" },
  { id: 33, name: "Essential Oil Diffuser", category: "Health & Beauty", price: 24.99, minOrder: 150, image: "https://images.unsplash.com/photo-1608571423902-eed4a5ad8108?w=400" },
  { id: 34, name: "Bamboo Toothbrush Pack", category: "Health & Beauty", price: 8.99, minOrder: 500, image: "https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=400" },
  { id: 35, name: "Face Mask Sheet (20 Pack)", category: "Health & Beauty", price: 18.99, minOrder: 200, image: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400" },
  { id: 36, name: "Hair Brush Set Professional", category: "Health & Beauty", price: 15.99, minOrder: 250, image: "https://images.unsplash.com/photo-1522338140262-f46f5913618a?w=400" },
  { id: 37, name: "Organic Body Lotion 500ml", category: "Health & Beauty", price: 14.99, minOrder: 200, image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400" },
  { id: 38, name: "Makeup Brush Set 12pc", category: "Health & Beauty", price: 22.99, minOrder: 150, image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400" },
  
  // Sports & Outdoors (39-44)
  { id: 39, name: "Yoga Mat Premium 6mm", category: "Sports & Outdoors", price: 24.99, minOrder: 150, image: "https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=400" },
  { id: 40, name: "Resistance Bands Set", category: "Sports & Outdoors", price: 18.99, minOrder: 200, image: "https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=400" },
  { id: 41, name: "Camping Tent 4 Person", category: "Sports & Outdoors", price: 89.99, minOrder: 30, image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=400" },
  { id: 42, name: "Sports Water Bottle 1L", category: "Sports & Outdoors", price: 12.99, minOrder: 300, image: "https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=400" },
  { id: 43, name: "Jump Rope Speed Pro", category: "Sports & Outdoors", price: 9.99, minOrder: 400, image: "https://images.unsplash.com/photo-1434682881908-b43d0467b798?w=400" },
  { id: 44, name: "Dumbbell Set Adjustable", category: "Sports & Outdoors", price: 75.99, minOrder: 50, image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400" },
  
  // Office Supplies (45-48)
  { id: 45, name: "Desk Organizer Wooden", category: "Office Supplies", price: 28.99, minOrder: 150, image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400" },
  { id: 46, name: "Notebook Set A5 (10 Pack)", category: "Office Supplies", price: 14.99, minOrder: 300, image: "https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=400" },
  { id: 47, name: "Ballpoint Pen Box (50 pc)", category: "Office Supplies", price: 12.99, minOrder: 200, image: "https://images.unsplash.com/photo-1585336261022-680e295ce3fe?w=400" },
  { id: 48, name: "Sticky Notes Assorted Pack", category: "Office Supplies", price: 8.99, minOrder: 400, image: "https://images.unsplash.com/photo-1586282391129-76a6df230234?w=400" },
  
  // Automotive (49-50)
  { id: 49, name: "Car Phone Mount Universal", category: "Automotive", price: 14.99, minOrder: 250, image: "https://images.unsplash.com/photo-1609709295948-17d77cb2a69b?w=400" },
  { id: 50, name: "Car Cleaning Kit Complete", category: "Automotive", price: 34.99, minOrder: 100, image: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=400" }
];

export const whyChooseUs = [
  {
    title: "Global Network",
    description: "Established partnerships in over 50 countries worldwide"
  },
  {
    title: "Quality Guaranteed",
    description: "All products undergo strict quality control inspections"
  },
  {
    title: "Competitive Pricing",
    description: "Direct sourcing ensures the best prices for our clients"
  },
  {
    title: "Fast Delivery",
    description: "Efficient logistics network for timely deliveries"
  }
];

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "About", href: "/about" },
  { name: "Products", href: "/products" },
  { name: "Services", href: "/services" },
  { name: "Contact", href: "/contact" }
];
